<template>
  <q-card class="shadow-3">
    <q-img
      v-if="imageUrl"
      :src="imageUrl"
      style="height: 150px; object-fit: contain; object-position: bottom;"
    />
    <div class="q-pa-sm">
      <slot/>
    </div>
  </q-card>
</template>

<script setup lang="ts">
import { defineProps } from "vue";

const { imageUrl } = defineProps({
  imageUrl: {
    type: String,
    default: "",
  },
});
</script>